<section class="container-xxl">
  @if (anchor) {
    <div [mbScrollSpy]="anchor"></div>
  }
  <mb-info [type]="infoType">
    <div class="magazine-info-content-wrapper">
      @if (headline) {
        <h3 class="h4 mb-info-heading-cs">
          @if (config.iconClass) {
            <i class="mb-icon {{ config.iconClass }}"></i>
          }
          <span>{{ headline | translate }}</span>
        </h3>
      }
      @if (text) {
        <p class="copy-xl">{{ text | translate }}</p>
      }
      @if (buttonLabel) {
        @switch (linkType) {
          @case ('external') {
            <a class="btn {{ config.buttonClass }}" [href]="buttonLink" target="_{{ buttonTargetType }}">
              {{ buttonLabel }}
            </a>
          }
          @case ('internal') {
            <a class="btn {{ config.buttonClass }}" [routerLink]="buttonLink">
              {{ buttonLabel }}
            </a>
          }
          @case ('modal') {
            <button class="btn {{ config.buttonClass }}" (click)="openQaForm()">
              {{ buttonLabel }}
            </button>
          }
        }
      }
    </div>
  </mb-info>
</section>
